import { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";

const APIDropdown = ({ selectedHost, setSelectedHost, apiHosts }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const [buttonPos, setButtonPos] = useState({ top: 0, left: 0, width: 0 });

  const handleSelect = (host) => {
    setSelectedHost(host.value);
    localStorage.setItem("apiHost", host.value);
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setButtonPos({
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
        width: rect.width
      });
    }
  }, [open]);

  return (
    <>
      {/* Button */}
      <button
        ref={buttonRef}
        onClick={() => setOpen(!open)}
        className="bg-white/5 backdrop-blur-md border border-white/20 text-white text-sm px-4 py-2 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-yellow-400 transition-all duration-200 flex items-center space-x-2"
      >
        <span>{apiHosts.find(h => h.value === selectedHost)?.label || "Select API"}</span>
        <svg className={`h-4 w-4 transform transition-transform ${open ? "rotate-180" : ""}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.292l3.71-4.06a.75.75 0 111.08 1.04l-4.25 4.65a.75.75 0 01-1.08 0l-4.25-4.65a.75.75 0 01.02-1.06z" clipRule="evenodd" />
        </svg>
      </button>

      {/* Dropdown */}
      {open && createPortal(
        <div
          ref={dropdownRef}
          className="absolute z-[9999] mt-2 w-48 rounded-lg shadow-lg bg-white/10 backdrop-blur-md border border-white/20 py-2"
          style={{ position: 'absolute', top: buttonPos.top, left: buttonPos.left, width: buttonPos.width }}
        >
          {apiHosts.map((host) => (
            <div
              key={host.value}
              onClick={() => handleSelect(host)}
              className="text-white px-4 py-2 text-sm hover:bg-yellow-400/20 cursor-pointer transition-all"
            >
              {host.label}
            </div>
          ))}
        </div>,
        document.body
      )}
    </>
  );
};

export default APIDropdown;
